import styled from 'styled-components';

const ServicesStyle = styled.section`
	.articleWrap {
		counter-reset: my-sec-counter;

		.article-item {
			.tableWrap {
				padding-top: var(--titleToContent);
			}
		}
	}

	.portfolioWrap {
		.portfolioItem {
			padding: calc(var(--sectionToSection) / 2) 0;

			a {
				display: block;
			}

			.image_video_cont {
				position: relative;
				margin-bottom: var(--sp2-5x);

				.image_video {
					padding-top: 75%;
				}

				video {
					position: absolute;
					z-index: 1;
					inset: 0;
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			h5,
			p {
				margin-bottom: var(--sp1x);

				&:last-child {
					margin-bottom: 0;
				}
			}
		}

		> div {
			opacity: 0;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--itemMarg: var(--sp2-5x);

			display: flex;
			flex-wrap: wrap;
			margin: 0 calc(var(--itemMarg) * -1);

			.portfolioItem {
				width: 50%;
				padding: calc(var(--sectionToSection) / 2) var(--itemMarg) calc(var(--sectionToSection) / 2);
			}

			.moreInfoLink {
				padding: 0 var(--itemMarg);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--maxWidth: 83%;

			max-width: var(--maxWidth);

			.portfolioItem {
				padding: calc(var(--sectionToSection) / 2) var(--itemMarg) calc(var(--sectionToSection) / 2);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--itemMarg: var(--sp1x);
			--maxWidth: calc(100% + var(--itemMarg) * 2);

			.portfolioItem {
				width: 40%;
				padding: calc(var(--sectionToSection) / 2) var(--itemMarg) 0;
			}

			.moreInfoLink {
				width: 20%;
				margin-top: 14%;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			--itemMarg: var(--sp2-5x);

			.portfolioItem {
				width: 39%;
			}

			.moreInfoLink {
				width: 22%;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			--itemMarg: var(--sp4x);

			.portfolioItem {
				padding: calc(var(--sectionToSection) / 2) var(--itemMarg) 0;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			.portfolioItem {
				padding: calc(var(--sectionToSection) / 2) var(--itemMarg) 0;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--itemMarg: var(--sp6x);

			.portfolioItem {
				width: 37.4%;

				.image_video_cont {
					.image_video {
						margin-bottom: var(--sp5x);
					}
				}

				h5,
				p {
					margin-bottom: var(--sp1x);
				}
			}
		}
	}
`;

export default ServicesStyle;
